<template>
    <div class="o-guide-view-bubbles guide-view-bubbles">
        <MapLabel
            v-show="hideBubbles"
            :selected-unit="guideStepIndex"
            :target="target"
            :position-x="activeGuideStepPosition['position-x']"
            :position-y="activeGuideStepPosition['position-y']"
            :offset-x="offsetX"
            :offset-y="offsetY"
            @click.native="setActiveGuideStep(step.index)"
            ref="mapLabel"
            :class="[
                'guide-view__dialog-wrapper',
                `step-direction--${activeGuideStepPosition.class}`
            ]"
        >
            <slot></slot>
        </MapLabel>
    </div>
</template>

<script>
import { getScale } from '@/utils/helpers/fit-to-screen';
import MapLabel from "../../../shared/components/map-viewer/labels/map-label";

import { UI_ON_CAMERA_UPDATE } from "../../../shared/components/map-viewer/constants/map-events";

import debounce from 'lodash/debounce';
import uniqWith from 'lodash/uniqWith';
import isEqual from 'lodash/isEqual';
import remove from 'lodash/remove';

import {
    mapState,
    mapGetters
} from 'vuex'

import {
    getTargetScreenPos,
    getStepTopScreenPos,
    getPointOnFloorScreenPos
} from '../../../utils/services'

export default {
    name: 'OGuideViewBubbles',
    inject: ['mapViewer'],
    components: {
        MapLabel,
    },
    props: {
        step: {
            type: Object,
            required: true
        },
        guideSteps: {
            type: Array,
            required: true
        },
        guideStepIndex: {
            type: [Number, String],
            required: true
        },
        target: {
            type: String,
            default: 'unit'
        },
        vertices: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        activeGuideStepPosition: {
            'position-x': 'middle',
            'position-y': 'bottom',
            'class': 'middle-top'
        },
        canCheckBubblesPosition: true,
        offsetX: -21,
        offsetY: 15,
        updateOrientationTimeout: null,
        descriptionStepPosition : {
            leftTop: {
                'position-x': 'left',
                'position-y': 'bottom',
                'class': 'left-top'
            },
            rightTop: {
                'position-x': 'right',
                'position-y': 'bottom',
                'class': 'right-top'
            },
            middleTop: {
                'position-x': 'middle',
                'position-y': 'bottom',
                'class': 'middle-top'
            },
            leftBottom: {
                'position-x': 'left',
                'position-y': 'top',
                'class': 'left-bottom'
            },
            rightBottom: {
                'position-x': 'right',
                'position-y': 'top',
                'class': 'right-bottom'
            },
            middleBottom: {
                'position-x': 'middle',
                'position-y': 'top',
                'class': 'middle-bottom'
            }
        },
        hideBubbles: true
    }),
    computed: {
        ...mapState({
            isLandscape: state => state.landscape,
            locale: state => state.activeLocale
        }),
        ...mapGetters([
            'getMapConfigProp'
        ]),
        isMobile(){
            return document.location.href.includes('mobile')
        }
    },
    methods: {
        initEventListenersBubblesPosition() {
            this.$bus.$on(UI_ON_CAMERA_UPDATE, this.updateOrientation);
        },
        deactivateEventListenersBubblesPosition() {
            this.$bus.$off(UI_ON_CAMERA_UPDATE, this.updateOrientation);
        },
        // async updateOrientation() {
        //     console.log('before if', this.canCheckBubblesPosition)
        //     if(this.canCheckBubblesPosition) {
        //         try {
        //             await this.checkBubblesPosition()
        //             console.log('test')
        //         } catch (e) {
        //             console.log(e, 'cahange bubbles position error')
        //         } finally {
        //             // we want to do this check no more than once every 1000ms
        //             this.canCheckBubblesPosition = false
        //             this.updateOrientationTimeout =  setTimeout(async () => {
        //                 this.canCheckBubblesPosition = true
        //                 await this.checkBubblesPosition()
        //             }, 1000)
        //         }
        //     }
        // },
        checkBubblesPosition() {
            let position = null;

            if(!this.hideBubbles) {
                this.hideBubbles = true
                this.$nextTick(() => {
                    if(this.$refs.mapLabel && (this.checkVertexInclude() || this.checkNeighboringBubblesPosition() || this.checkBubblesPositionRelativeScreen())) {
                        position = this.changePosition()
                    }
                })
            } else if(this.$refs.mapLabel && (this.checkVertexInclude() || this.checkNeighboringBubblesPosition() || this.checkBubblesPositionRelativeScreen())) {
                position = this.changePosition()
            }

            if (position && this.activeGuideStepPosition !== position) this.activeGuideStepPosition = position
        },
        /**
         * this function checks if the bubble does not cross the border of the map, if it crosses we need to change the position of the bubble
         * @param bubble object - the coordinates of the bubble we want to check
         * @return {Boolean} , true if bubble cross the border of the map
         */
        checkBubblesPositionRelativeScreen(bubble) {
            const bubblePosition = bubble || (this.$refs.mapLabel && this.$refs.mapLabel._vnode.elm.getBoundingClientRect())

            const headerHeight = this.isMobile ?
                this.isLandscape ? 0 :document.querySelector('.m-header').clientHeight
                : document.querySelector('.header').clientHeight
            const mapParameters = document.querySelector('.mapviewer__iframe').getBoundingClientRect()
            const footerHieght = document.querySelector('.o-mobile-guide-start')
                ? document.querySelector('.o-mobile-guide-start').clientHeight
                : 0

            const topBubblesPosition = bubblePosition.y - headerHeight
            const bottomBubblesPosition = this.isMobile
                ? document.documentElement.clientHeight - bubblePosition.y - bubblePosition.height - footerHieght
                : document.documentElement.clientHeight - bubblePosition.y - bubblePosition.height
            const rigthBubblesPosition  = document.documentElement.clientWidth - bubblePosition.x - bubblePosition.width
            const leftBubblesPosition = bubblePosition.x - mapParameters.x

            if(topBubblesPosition <= 0 || rigthBubblesPosition <= 0 || leftBubblesPosition <= 0 || bottomBubblesPosition <= 0) {
                return true
            } else {
                return false
            }

        },
        setActiveGuideStep(index) {
            this.$emit('setActiveGuideStep', index)
        },
        changeOffset() {
            const bubblePosition = this.$refs.mapLabel && this.$refs.mapLabel._vnode.elm.getBoundingClientRect()

            const arrowPosition = this.$refs.mapLabel._vnode.elm.querySelector('.dialog__arow').getBoundingClientRect()

            if( // change offsetX
                this.activeGuideStepPosition === this.descriptionStepPosition.middleBottom
                || this.activeGuideStepPosition === this.descriptionStepPosition.middleTop
            ) {
                this.offsetX = 0
            } else if (
                this.activeGuideStepPosition === this.descriptionStepPosition.rightTop
                || this.activeGuideStepPosition === this.descriptionStepPosition.rightBottom
            ) {
                this.offsetX = arrowPosition.right - bubblePosition.right
            } else {
                this.offsetX = bubblePosition.left - arrowPosition.left
            }

            if( // change offsetY
                this.activeGuideStepPosition === this.descriptionStepPosition.middleBottom
                || this.activeGuideStepPosition === this.descriptionStepPosition.leftBottom
                || this.activeGuideStepPosition === this.descriptionStepPosition.rightBottom
            ) {
                this.offsetY = bubblePosition.top - arrowPosition.top
            } else {
                this.offsetY = arrowPosition.bottom - bubblePosition.bottom
            }

        },
        /**
         *  this function checking vertex inside bubbles
         *  @param bubble object - the coordinates of the bubble we want to check
         *  @param isStrictVertices boolean - if it is impossible to place the bubble so that it does not cross any vertex, priority is given to the vertices of the active step
         *  return Boolean , true if vertex inside bubbles
         */
        checkVertexInclude(bubble = null, isStrictVertices = false) {
            const verticesCordinate = isStrictVertices ? this.getVerticesCordinate(true) : this.getVerticesCordinate();

            const bubblePosition = bubble || (this.$refs.mapLabel && this.$refs.mapLabel._vnode.elm.getBoundingClientRect());

            const mapParameters = document.querySelector('.mapviewer__iframe').getBoundingClientRect();

            if(!bubblePosition || !mapParameters) return ;

            const xBubblesCoordinate = [bubblePosition.x - mapParameters.x, bubblePosition.x + bubblePosition.width - mapParameters.x];
            const yBubblesCoordinate = [bubblePosition.y - mapParameters.y, bubblePosition.y + bubblePosition.height - mapParameters.y];

            let isVertexInclude = false;

            let clientWidthOffset = 30;
            let clientHeightOffset = 15;

            if(!this.$route.query.terminalMode) {
                const scale = getScale();
                clientHeightOffset = clientHeightOffset*scale;
                clientWidthOffset = clientWidthOffset*scale;
            }

            verticesCordinate.forEach((vertex, index, arr) => {
                let xInclude = false
                let yInclude = false

                if(vertex.x >= xBubblesCoordinate[0] - clientWidthOffset && vertex.x <= xBubblesCoordinate[1] + clientWidthOffset) {
                    xInclude = true
                }
                if(vertex.y >= yBubblesCoordinate[0] - clientHeightOffset && vertex.y <= yBubblesCoordinate[1] + clientHeightOffset) {
                    yInclude = true
                }
                if( xInclude && yInclude) isVertexInclude = true
            });
            return isVertexInclude
        },
        /**
         *  this function return vertices which are closest to the active step so we can check if the bubble crosses the vertex
         *  @param isStrictVertices boolean - if it is impossible to place the bubble so that it does not cross any vertex, priority is given to the vertices of the active step,
         * then  vertices previous step and next step ignore
         * return Array
         */
        getVerticesCordinate(isStrictVertices = false) {
            const verticesCordinate = []

            if(typeof this.guideStepIndex !== 'number') {
                this.vertices.forEach( vertex => {
                    const floor = this.mapViewer.mapData.objects.find( o => o.id === vertex.floor )
                    const vertexCordinate = { ...getPointOnFloorScreenPos(vertex.position, floor.unit.name)}

                    verticesCordinate.push(vertexCordinate)
                })
                return verticesCordinate
            }

            const prevStepVerticesId =  this.guideStepIndex !== 0 ? this.guideSteps[this.guideStepIndex - 1].vertex_id : null // this is previous step vertexId
            const currentStepVerticesId = this.guideSteps[this.guideStepIndex].vertex_id // this is current step vertexId
            const nextStepVerticesId = this.guideStepIndex !== this.guideSteps.length - 1 ? this.guideSteps[this.guideStepIndex + 1].vertex_id : null  // this is next step vertexId
            const afterNextStepVerticesId = this.guideStepIndex < this.guideSteps.length - 2 ? this.guideSteps[this.guideStepIndex + 2].vertex_id : null  // this is after next step vertexId

            const prevStepVerticesIndex = prevStepVerticesId !== null ? this.vertices.findIndex(vert => vert.id === prevStepVerticesId) : null
            const currentStepVerticesIndex = this.vertices.findIndex(vert => vert.id === currentStepVerticesId) // we have all guide vertices(in props),  we need current vertex index of this all vertices
            const nextStepStepVerticesIndex = nextStepVerticesId !== null ? this.vertices.findIndex(vert => vert.id === nextStepVerticesId) : null
            const afterNextStepStepVerticesIndex = afterNextStepVerticesId !== null ? this.vertices.findIndex(vert => vert.id === afterNextStepVerticesId) : null

            const prevStepVertices = prevStepVerticesIndex !== null ?  this.vertices.slice(prevStepVerticesIndex, currentStepVerticesIndex + 1) : []
            const currentStepVertices = nextStepStepVerticesIndex !== null ?  this.vertices.slice(currentStepVerticesIndex, nextStepStepVerticesIndex + 1) : []
            const nextStepStepVertices = nextStepStepVerticesIndex !== null && afterNextStepStepVerticesIndex !== null ?  this.vertices.slice(nextStepStepVerticesIndex, afterNextStepStepVerticesIndex + 1) : []

            let allStepVertices = []

            if (isStrictVertices)  allStepVertices = [...currentStepVertices]
            else allStepVertices = [...prevStepVertices, ...currentStepVertices, ...nextStepStepVertices]

            allStepVertices.forEach( vertex => {
                const floor = this.mapViewer.mapData.objects.find( o => o.id === vertex.floor )
                const vertexCordinate = { ...getPointOnFloorScreenPos(vertex.position, floor.unit.name)}

                verticesCordinate.push(vertexCordinate) // verticesCordinate.push({...vertexCordinate, z : vertex.position.z})
            })

            let allVertices = this.addMoreVertices(verticesCordinate)

            if(!this.$route.query.terminalMode) {
                const scale = getScale();
                allVertices = allVertices.map(({x, y, z}) => ({x: x*scale, y: y*scale, z}))
            }

            return allVertices

        },
        /**
         *   --------- MAIN FUNCTION --------
         *  this function returns the new location of the bubble
         *  @return {Object}  - new bubbles location
         */
        changePosition() {
            const bubblePosition = this.$refs.mapLabel && this.$refs.mapLabel._vnode.elm.getBoundingClientRect();

            const mapParameters = document.querySelector('.mapviewer__iframe').getBoundingClientRect()
            let topStepNumberPosition = null
            switch (this.target) {
            case 'guide_step':
                topStepNumberPosition = getStepTopScreenPos(this.guideStepIndex)
                break
            default:
                topStepNumberPosition = getTargetScreenPos(this.target, this.guideStepIndex)
            }
            let clientOffsetHeight = 60;

            if(!this.$route.query.terminalMode) {
                const scale = getScale();
                topStepNumberPosition = {x: topStepNumberPosition.x*scale, y: topStepNumberPosition.y*scale, z: topStepNumberPosition.z*scale};
                clientOffsetHeight = clientOffsetHeight*scale;
            }

            const topMiddlePosition = {
                x: topStepNumberPosition.x - bubblePosition.width/2 + mapParameters.x,
                y: topStepNumberPosition.y - bubblePosition.height - this.offsetY + mapParameters.y,
                height: bubblePosition.height,
                width: bubblePosition.width
            }

            const topRightPosition = {
                x: topStepNumberPosition.x - bubblePosition.width - this.offsetX + mapParameters.x,
                y: topStepNumberPosition.y - bubblePosition.height - this.offsetY + mapParameters.y,
                height: bubblePosition.height,
                width: bubblePosition.width
            }

            const topLeftPosition = {
                x: topStepNumberPosition.x + this.offsetX+ mapParameters.x,
                y: topStepNumberPosition.y - bubblePosition.height - this.offsetY + mapParameters.y,
                height: bubblePosition.height,
                width: bubblePosition.width
            }

            const bottomMiddlePosition = {
                x: topStepNumberPosition.x - bubblePosition.width/2 + mapParameters.x,
                y: topStepNumberPosition.y + clientOffsetHeight + mapParameters.y,
                height: bubblePosition.height,
                width: bubblePosition.width
            }

            const bottomLeftPosition = {
                x: topStepNumberPosition.x - bubblePosition.width - this.offsetX + mapParameters.x,
                y: topStepNumberPosition.y + clientOffsetHeight + mapParameters.y,
                height: bubblePosition.height,
                width: bubblePosition.width
            }

            const bottomRightPosition = {
                x: topStepNumberPosition.x - bubblePosition.width - this.offsetX + mapParameters.x,
                y: topStepNumberPosition.y + clientOffsetHeight + mapParameters.y,
                height: bubblePosition.height,
                width: bubblePosition.width
            }

            if(this.checkBubblesPositionFunctions(topMiddlePosition)) {
                return this.descriptionStepPosition.middleTop
            } else if(this.checkBubblesPositionFunctions(topRightPosition)) {
                return this.descriptionStepPosition.rightTop
            } else if(this.checkBubblesPositionFunctions(topLeftPosition)) {
                return this.descriptionStepPosition.leftTop
            } else if(this.checkBubblesPositionFunctions(bottomRightPosition)) {
                return this.descriptionStepPosition.rightBottom
            } else if(this.checkBubblesPositionFunctions(bottomLeftPosition)) {
                return this.descriptionStepPosition.leftBottom
            } else if(this.checkBubblesPositionFunctions(bottomMiddlePosition)) {
                return this.descriptionStepPosition.middleBottom
            } else if(this.checkBubblesPositionFunctions(topMiddlePosition, true)) {
                return this.descriptionStepPosition.middleTop
            } else if(this.checkBubblesPositionFunctions(topRightPosition, true)) {
                return this.descriptionStepPosition.rightTop
            } else if(this.checkBubblesPositionFunctions(topLeftPosition, true)) {
                return this.descriptionStepPosition.leftTop
            } else if(this.checkBubblesPositionFunctions(bottomRightPosition, true)) {
                return this.descriptionStepPosition.rightBottom
            } else if(this.checkBubblesPositionFunctions(bottomLeftPosition, true)) {
                return this.descriptionStepPosition.leftBottom
            } else if(this.checkBubblesPositionFunctions(bottomMiddlePosition, true)) {
                return this.descriptionStepPosition.middleBottom
            } else {
                this.$nextTick(() => { if (this.checkNeighboringBubblesPosition(bottomMiddlePosition) || this.checkBubblesPositionRelativeScreen(bottomMiddlePosition)) this.hideBubbles = false })
                return this.descriptionStepPosition.middleBottom
            }
        },
        /**
         * if the distance between the vertices is too large, additional vertices must be added
         * @param vetrices - Array required
         */
        addMoreVertices(vertices) {
            let verticesCordinate = vertices

            const distanceBeetwenVertices = this.getMapConfigProp('distanceBeetwenVertices', 50)

            verticesCordinate.forEach((vertex, index, arr) => {
                let vertices = []
                let xCordinate = []
                let yCordinate = []

                let numberNewPoint = 0
                const newCordinate = []

                if(index !== arr.length -1) {
                    vertices = [vertex, arr[index + 1]]
                } else {
                    return
                }
                xCordinate = [vertices[0].x, vertices[1].x]
                yCordinate = [vertices[0].y, vertices[1].y]

                if(xCordinate[1] - xCordinate[0] > distanceBeetwenVertices || yCordinate[1] - yCordinate[0] > distanceBeetwenVertices || xCordinate[1] - xCordinate[0] < -distanceBeetwenVertices || yCordinate[1] - yCordinate[0] < -distanceBeetwenVertices) {
                    numberNewPoint = Math.abs(xCordinate[1] - xCordinate[0]) > Math.abs(yCordinate[1] - yCordinate[0])
                        ? Math.abs(Math.floor((xCordinate[1] - xCordinate[0])/distanceBeetwenVertices))
                        : Math.abs(Math.floor((yCordinate[1] - yCordinate[0])/distanceBeetwenVertices))

                    for(let i = 0; i < numberNewPoint; i++) {
                        newCordinate.push({
                            x: (xCordinate[0] + (newCordinate[i - 1] ? newCordinate[i - 1].x  : xCordinate[1]))/2,
                            y: (yCordinate[0] + (newCordinate[i - 1] ? newCordinate[i - 1].y  : yCordinate[1]))/2,
                            // z: vertex.z,
                            // customPoint: true // we use this line during development can be removed
                        })

                        newCordinate.push({
                            x: (xCordinate[1] + (newCordinate[i - 1] ? newCordinate[i - 1].x  : xCordinate[0]))/2,
                            y: (yCordinate[1] + (newCordinate[i - 1] ? newCordinate[i - 1].y  : yCordinate[0]))/2,
                            // z: vertex.z,
                            // customPoint: true // we use this line during development can be removed
                        })
                    }
                    verticesCordinate = [...verticesCordinate, ...newCordinate]
                } else {
                    return
                }
            })

            return uniqWith(verticesCordinate, isEqual)
        },
        /**
         * this function checks the location of adjacent bubbles, and if they intersect with this bubble, we change the position of the bubble
         * @param bubble object - the coordinates of the bubble we want to check
         * return boolean
         */
        checkNeighboringBubblesPosition(bubble = null) {
            const bubblePosition = this.getElementPosition(this.$refs.mapLabel._vnode.elm)
            const currentBubblePosition = bubble || bubblePosition
            const bubbles = document.querySelectorAll('.guide-view__dialog-wrapper')
            const bubblesPosition = []

            const xCurrentBubblesCordinate = [currentBubblePosition.x, currentBubblePosition.x + currentBubblePosition.width ]
            const yCurrentBubblesCordinate = [currentBubblePosition.y, currentBubblePosition.y + currentBubblePosition.height]

            let intersect = false

            bubbles.forEach(element => {
                bubblesPosition.push(this.getElementPosition(element))
            });

            remove(bubblesPosition, currentObject => isEqual(currentObject, bubblePosition))

            bubblesPosition.forEach((element, index) => {
                let xInclude = false
                let yInclude = false
                if(
                    (element.x > xCurrentBubblesCordinate[0] - 5 && element.x < xCurrentBubblesCordinate[1] + 5)
                    || (element.x + element.width > xCurrentBubblesCordinate[0] - 5 && element.x + element.width < xCurrentBubblesCordinate[1] + 5)
                ) xInclude = true
                if(
                    (element.y > yCurrentBubblesCordinate[0] - 5 && element.y < yCurrentBubblesCordinate[1] + 5)
                    || element.y + element.height > yCurrentBubblesCordinate[0] - 5 && element.y + element.height < yCurrentBubblesCordinate[1] + 5
                ) yInclude = true

                if(xInclude && yInclude) intersect = true
            })

            if(intersect && typeof this.guideStepIndex === 'number') {
                return intersect
            } else {
                return intersect
            }
        },
        /**
         * function element.getBoundingClientRect() return DOMRect
         * DOMRect is not the standart object
         * this function @return {object} with element cordinate
         */
        getElementPosition(element) {
            const rect = element.getBoundingClientRect();
            return {
                top: rect.top,
                right: rect.right,
                bottom: rect.bottom,
                left: rect.left,
                width: rect.width,
                height: rect.height,
                x: rect.x,
                y: rect.y
            };
        },
        /**
         * helper
         * @return {boolean}
         */
        checkBubblesPositionFunctions(bubble, isStrictVertices = false) {
            return (
                !this.checkVertexInclude(bubble, isStrictVertices)
                && !this.checkNeighboringBubblesPosition(bubble)
                && !this.checkBubblesPositionRelativeScreen(bubble)
            )
        }
    },
    watch: {
        isLandscape() {
            setTimeout(() => {
                // this.activeGuideStepPosition = {}
                // this.checkBubblesPosition()
                this.$bus.$emit(UI_ON_CAMERA_UPDATE)
            }, 100)
        },
        locale() {
            this.$nextTick(() => {
                this.activeGuideStepPosition = {}
                this.checkBubblesPosition()
            })
        },
        activeGuideStepPosition() {
            this.$nextTick(() => this.changeOffset())
        }
    },
    mounted() {
        this.activeGuideStepPosition = this.descriptionStepPosition.middleTop
        this.initEventListenersBubblesPosition()
    },
    created() {
        this.updateOrientation = debounce(() => {
            this.checkBubblesPosition();
            setTimeout(() => {
                this.checkBubblesPosition()
            }, 100)
        }, 300)
    },
    beforeDestroy() {
        this.deactivateEventListenersBubblesPosition()
        clearTimeout(this.updateOrientationTimeout)
    }
}
</script>

<style lang="scss">
@import "o-guide-view-bubbles";
</style>
